module.exports = __webpack_public_path__ + "static/logo-tesla-7c72bfce1851cecd20a7febe1cf702de.png";